import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #4b5563;
`;

export const BreadcrumbButton = styled.button<{ $isActive?: boolean }>`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: ${props => (props.$isActive ? '#111827' : '#4b5563')};
    font-weight: ${props => (props.$isActive ? '500' : '400')};
    transition: color 0.15s ease;

    &:hover {
        color: #111827;
    }
`;

export const BreadcrumbSeparator = styled.span`
    color: #9ca3af;
    display: flex;
    align-items: center;
`;

export const BreadcrumbSegment = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
